<div data-cy="integration-modal-bouwapp-project-level__page" class="row popup-container" *transloco="let t">
  <div class="popup-header row no-margin ">
    <div class="col-xs-12 mb-5">
      <h1><strong>{{ t('admin_page.integration') | titlecase}} </strong><span class="">{{displayData}}</span></h1>
      <button data-cy="integration-modal-bouwapp-project-level__close-btn" type="button" class="close " (click)="close()"><span aria-hidden="true">
          <mat-icon class="d-text-middle">close</mat-icon>
        </span><span class="sr-only">Close</span></button>
    </div>
  </div>

  <div class="popup-body" appScroll>
    <!-- Non-admin view: Request admin to integrate -->
    <div class="col-xs-12 mb-5" *ngIf="!isAdmin">
      <div>
        <div style="display: flex; align-items: center; margin-bottom: 8px;">
          <mat-icon
            style="color: #4caf50; margin-right: 12px; font-size: 24px; width: 24px; height: 24px;">check_circle</mat-icon>
          <span style="font-size: 14px;">{{ t('settings.bouwapp.integration_possible') }}</span>
        </div>
        <div style="display: flex; align-items: start; row-gap: 16px;">
          <p style="color: #333; margin-bottom: 20px; font-size: 14px; line-height: 1.5; flex: 1;">
            {{ t('settings.bouwapp.integration_description') }}
          </p>
          <button data-cy="integration-modal-bouwapp-project-level__btn" type="button" class="btn btn-primary color-btn-primary-map"
            style="padding: 8px 24px; border-radius: 4px; margin: 0">
            {{ t('settings.request') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Admin view: Existing integration flow -->
    <div class="col-xs-12 mb-5" *ngIf="isAdmin && !isProcess">
      <h5> {{ t('settings.connection') | titlecase}}</h5>
      <div class="set-border-connection">
        <span class="align-set" *ngIf="!bouwappenable && !errorMessage">{{ t('settings.bouwapp.bouwapp_integration') |
          capitaliz}}</span>
        <div class="align-set display-flex" *ngIf="errorMessage">
          <mat-icon class="d-text-middle">error</mat-icon>
          <span class="error-message align-set"> {{ t('error.bouwapp_integration') | capitaliz}}</span>
        </div>
        <div class="align-set display-flex" *ngIf="bouwappenable && !errorMessage">
          <mat-icon class="successfully-message d-text-middle" *ngIf="!alertMessage">check_circle</mat-icon>
          <mat-icon class="warn-msg d-text-middle" *ngIf="alertMessage">warning</mat-icon>
          <span class="align-set" *ngIf="!alertMessage"> {{ t('success.bouwapp_integration') | capitaliz}}</span>
          <span class="align-set" *ngIf="alertMessage"> {{ t('success.bouwapp_warning_msg') | capitaliz}}</span>
        </div>
        <button data-cy="integration-modal-bouwapp-project-level__btn-2" [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsCreate)"
          *ngIf="bouwappenable" class="btn btn-primary color-btn-primary-mapa align-set" type="button"
          (click)="redirectURL()">
          <mat-icon class="icon-connect d-text-middle">remove_circle</mat-icon>
          {{ t('settings.disable') | titlecase}}
        </button>
        <button data-cy="integration-modal-bouwapp-project-level__btn-3" [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsCreate)"
          *ngIf="!bouwappenable" class="btn btn-primary color-btn-primary-map align-set" type="button"
          (click)="redirectURL()">
          <mat-icon class="d-text-middle icon-connect">add_circle</mat-icon>
          {{ t('settings.connect_me') }}
        </button>
      </div>
    </div>
    <div class="col-xs-12 mb-5">
      <mat-progress-bar *ngIf="isProcess" mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="isAdmin && !isProcess && bouwappenable && !errorMessage">
      <div class="col-xs-12 mb-5">
        <h5> {{ t('settings.bouwapp.setting') | titlecase}}</h5>
        <div class="subtext mb-5">{{ t('settings.bouwapp.setting_subtext')}}</div>
        <div class="set-border-connection">
          <div class="col-xs-12">
            <h5><strong> {{ t('settings.bouwapp.link_projects') | titlecase}}</strong></h5>
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <th class="w-40 vertical-align-middle">
                    <p>{{ level == 'company' ? projectname : globals.project.name | trunc }}</p>
                  </th>
                  <td>
                    <!-- <app-generic-multiselect-checkbox [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)" [multiple]="false" [placeholder]="t('settings.bouwapp.bouwapp_project')" name="mainProject" [(ngModel)]="mainProject" (ngModelChange)="mainProjectCall()">
                                            <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' | transloco}}
                                            </app-generic-multiselect-checkbox-option-all>
                                            <app-generic-multiselect-checkbox-option *ngFor="let item of bouwappProjects; trackBy: trackByFn" [value]="item">
                                                {{ item.name }}
                                            </app-generic-multiselect-checkbox-option>
                                        </app-generic-multiselect-checkbox> -->
                    <app-generic-uniselect
                      [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)"
                      [placeholder]="t('settings.bouwapp.bouwapp_project')" [selectedValue]="mainProject"
                      (onThemeSelected)="mainProjectCall($event)" [items]="bouwappProjects"
                      [uniqueId]="'bouwapp-project'"></app-generic-uniselect>
                  </td>
                  <td>
                    <app-generic-multiselect-checkbox data-cy="integration-modal-bouwapp-project-level__generic-multiselect-checkbox"
                      [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)"
                      [multiple]="true" [placeholder]="t('settings.bouwapp.user_access_placeholder')"
                      [(ngModel)]="mainProjectSelectedUsers" (ngModelChange)="onUserAccessChange(null, $event)"
                      [uniqueId]="'bouwapp-user-access-main'"
                      [maxChipMessage]="'+ {count} '+('reusable.more' | transloco)+' users ...'">
                      <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' |
                        transloco}}</app-generic-multiselect-checkbox-option-all>
                      <app-generic-multiselect-checkbox-option *ngFor="let user of users; trackBy: trackByFn"
                        [value]="user">{{ user.name }}</app-generic-multiselect-checkbox-option>
                    </app-generic-multiselect-checkbox>
                  </td>
                </tr>
                <tr *ngFor="let td of dialogProjects; let i=index">
                  <th class="w-40 vertical-align-middle">
                    <p>{{td.name}}</p>
                  </th>
                  <td>
                    <!-- <app-generic-multiselect-checkbox [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)" [multiple]="false" [placeholder]="t('settings.bouwapp.bouwapp_project')" name="bouwappprojects" [(ngModel)]="bouwsubprojects[i]" (ngModelChange)="projectSet(td.id,$event)" [uniqueId]="'sub-projects'">
                                            <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' | transloco}}
                                            </app-generic-multiselect-checkbox-option-all>
                                            <app-generic-multiselect-checkbox-option *ngFor="let item of bouwappProjects; trackBy: trackByFn" [value]="item">
                                                {{ item.name }}
                                            </app-generic-multiselect-checkbox-option>
                                        </app-generic-multiselect-checkbox> -->
                    <app-generic-uniselect
                      [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)"
                      [placeholder]="t('settings.bouwapp.bouwapp_project')" [selectedValue]="bouwsubprojects[i]"
                      (onThemeSelected)="projectSet(td.id,$event)" [items]="bouwappProjects"
                      [uniqueId]="'bouwapp-subproject-' + (i)" [index]="i"></app-generic-uniselect>
                  </td>
                  <td>
                    <app-generic-multiselect-checkbox data-cy="integration-modal-bouwapp-project-level__generic-multiselect-checkbox-2"
                      [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)"
                      [multiple]="true" [placeholder]="t('settings.bouwapp.user_access_placeholder')"
                      [(ngModel)]="subprojectSelectedUsers[i]" (ngModelChange)="onUserAccessChange(td.id, $event)"
                      [uniqueId]="'bouwapp-user-access-sub-' + (i)"
                      [maxChipMessage]="'+ {count} '+('reusable.more' | transloco)+' users ...'">
                      <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' |
                        transloco}}</app-generic-multiselect-checkbox-option-all>
                      <app-generic-multiselect-checkbox-option *ngFor="let user of users; trackBy: trackByFn"
                        [value]="user">{{ user.name }}</app-generic-multiselect-checkbox-option>
                    </app-generic-multiselect-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-xs-12 mb-5">
        <h5 class="mt-15"> {{ t('settings.bouwapp.sync_bouwapp') | titlecase}}</h5>
        <div class="subtext mb-5">{{ t('settings.bouwapp.sync_bouwapp_subtext')}}</div>
        <div class="set-border-connection">
          <div class="col-xs-12">
            <app-generic-multiselect-checkbox data-cy="integration-modal-bouwapp-project-level__generic-multiselect-checkbox-3"
              [disabled]="level == 'company' ? false : !hasPermission(Permission.ProjectIntegrationsUpdate)"
              [multiple]="true" [placeholder]="t('settings.bouwapp.bouwApp_items')" name="bouwappsync"
              [(ngModel)]="bouwappsyncSelection" (ngModelChange)="syncBouwAppProject($event)">
              <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' | transloco}}
              </app-generic-multiselect-checkbox-option-all>
              <app-generic-multiselect-checkbox-option *ngFor="let item of connectionSelect; trackBy: trackByFn"
                [value]="item">
                {{ item.value | capitaliz}}
              </app-generic-multiselect-checkbox-option>
            </app-generic-multiselect-checkbox>
          </div>
        </div>
        <div *ngIf="smartReportingEnabled">
          <div class="subtext mb-5">{{ 'settings.bouwapp.smart_reporting_enabled_as' | transloco}}</div>
          <div>
            <mat-button-toggle-group data-cy="integration-modal-bouwapp-project-level__smart-reporting-as" [(ngModel)]="smartReportingAs" (ngModelChange)="updateSyncBouwappProject()">
              <mat-button-toggle mat-flat-button value="requirements">{{'requirements.label' | transloco |
                capitaliz}}</mat-button-toggle>
              <mat-button-toggle mat-flat-button value="complaints">{{'complaints.label' | transloco |
                capitaliz}}</mat-button-toggle>
            </mat-button-toggle-group>
            <br>
            <br>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
      </div>
    </div>
  </div>
</div>